<template>
  <div>
    <MainHead ref="mainHeadChild" :fatherNavSelect="leftNavSelect"></MainHead>
    <el-container id="main_container" class="container" :style="rowHeight">
      <el-aside class="left_nav" v-if="false">
        <el-menu
          :default-active="$route.name"
          @select="leftNavSelect"
          :router="true"
          class="el-menu-vertical-demo"
        >
          <el-menu-item index="meetingList" :route="{ path: '/meetingList' }">
            <template slot="title">
              <i class="iconfont icon-huiyizhongxin-toupiao"></i>
              <span>会议列表</span>
            </template>
          </el-menu-item>
          <el-menu-item index="personal" :route="{ path: '/personal' }">
            <template slot="title">
              <i class="iconfont icon-jibenxinxi"></i>
              <span>个人资料</span>
            </template>
          </el-menu-item>
          <el-menu-item index="financial" :route="{ path: '/financial' }">
            <template slot="title">
              <i class="iconfont icon-chongzhizhongxin"></i>
              <span>充值中心</span>
            </template>
          </el-menu-item>
          <el-menu-item index="user" :route="{ path: '/user' }">
            <template slot="title">
              <i class="iconfont icon-yonghuguanli"></i>
              <span>用户管理</span>
            </template>
          </el-menu-item>
        </el-menu>
        <div class="home_fee_box">
          <span v-if="balanceMessage != ''">
            <i class="iconfont icon-huiyuan2"></i>
            {{ balanceMessage }}
          </span>
          <el-link type="primary" :underline="false" @click="recharge()">
            购买
          </el-link>
        </div>
      </el-aside>
      <el-main id="main" class="main">
        <router-view />
      </el-main>
    </el-container>
    <el-dialog
      title="提示"
      :visible.sync="feeWranVisible"
      width="380px"
      top="15%"
      :center="true"
      :show-close="false"
    >
      <div>您目前没有可用会议次数，请及时充值或联系客服：</div>
      <div><i class="iconfont icon-dianhua"></i>010-82800223</div>
      <div><i class="iconfont icon-shouji"></i>13031051856</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="feeWranVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MainHead from '@/components/MainHead.vue'
export default {
  name: 'Main',
  components: {
    MainHead
  },
  provide () {
    return {
      mainHeadGetMeetingList: this.mainHeadGetMeetingList
    }
  },
  data () {
    return {
      rowHeight: {
        height: window.innerHeight - 56 + 'px'
      },
      balanceMessage: '',
      feeWranVisible: false
    }
  },
  methods: {
    leftNavSelect: function (key, keyPath) {
      switch (key) {
        case 'meetingList':
          this.$router.push({ path: '/meetingList' })
          break
        case 'personal':
          this.$router.push({ path: '/personal' })
          break
        case 'financial':
          this.$router.push({ path: '/financial' })
          break
        case 'user':
          this.$router.push({ path: '/user' })
          break
        case 'company':
          this.$router.push({ path: '/company' })
          break
        case 'userPostQuery':
          this.$router.push({ path: '/userPostQuery' })
          break
      }
    },
    getUserMoneyBalanceInfo () {
      this.$api.moneyUsering.getUserMoneyBalanceInfo().then(data => {
        this.balanceMessage = data.BalanceInfo
        this.getShowFeeWarn()
      }).catch(err => {
        return err
      })
    },
    mainHeadGetMeetingList () {
      this.$refs.mainHeadChild.getMeetingList()
    },
    recharge: function () {
      this.$router.push({ path: '/financial' })
    },
    getShowFeeWarn: function () {
      const _this = this
      const fellWarn = JSON.parse(localStorage.getItem('FeeWarn'))
      if (!fellWarn.isDisplayed) {
        fellWarn.isDisplayed = true
        if (_this.balanceMessage.IsBalanceClear) {
          _this.feeWranVisible = true
        }
        localStorage.setItem('FeeWarn', JSON.stringify(fellWarn))
      }
      // this.feeWranVisible = true
    }
  },
  created () {
    if (this.$store.state.isLogin) {
      this.getUserMoneyBalanceInfo()
    }
  }
}
</script>
